import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/unconfirmed_booking/'

export default {
  cancel (baseUrl, id) {
    return axios.get(baseUrl + URL + `cancel/${id}`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  confirm (baseUrl, id) {
    return axios.get(baseUrl + URL + `confirm/${id}`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
}
